// extracted by mini-css-extract-plugin
module.exports = {"countdown-banner":"CountdownBanner_countdown-banner__XNgEE"};